import { render, staticRenderFns } from "./TemplateMode.vue?vue&type=template&id=06419535&scoped=true"
import script from "./TemplateMode.vue?vue&type=script&lang=ts"
export * from "./TemplateMode.vue?vue&type=script&lang=ts"
import style0 from "./TemplateMode.vue?vue&type=style&index=0&id=06419535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06419535",
  null
  
)

export default component.exports